<template>
    <div>
        <div class="row">
            <div class="col-12">
            <router-link class="ml-1" to=""><div @click="$router.back()">Back</div></router-link>
            </div>
        </div>
        <div class="row" v-if="computer">
            <div class="col-lg-12 col-xl-7">
                <card :title="`${computer.system_vendor} ${computer.system_model} ${computer.system_serial}`">
                    <template v-slot:header-right>
                        <button class="btn btn-sm btn-outline-info" @click="fetchCertificate" :class="!isValid ? 'disabled' : ''">Certificate</button>
                    </template>
                        <small class="ml-2">Checksum {{ computer.hash }}</small>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th scope="row">Created at</th>
                                    <td>{{ computer.created_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Updated at</th>
                                    <td>{{ computer.updated_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Uploaded at</th>
                                    <td>{{ computer.uploaded_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Report revision</th>
                                    <td>{{ computer.revision }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Software version</th>
                                    <td>{{ computer.software_version }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Batch name</th>
                                    <td>{{ computer.batch_name }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Report name</th>
                                    <td>{{ computer.report_id }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System vendor</th>
                                    <td>{{ computer.system_vendor }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System model</th>
                                    <td>{{ computer.system_model }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System UUID</th>
                                    <td>{{ computer.system_uuid }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System serial</th>
                                    <td>{{ computer.system_serial }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System family</th>
                                    <td>{{ computer.system_family }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">System SKU number</th>
                                    <td>{{ computer.system_sku_number }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Chassis type</th>
                                    <td>{{ computer.chassis_type }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Chassis asset tag</th>
                                    <td>{{ computer.chassis_asset_tag }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Chassis serial</th>
                                    <td>{{ computer.chassis_serial }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">BIOS</th>
                                    <td>{{ computer.bios }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Baseboard vendor</th>
                                    <td>{{ computer.baseboard_vendor }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Baseboard model</th>
                                    <td>{{ computer.baseboard_model }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Baseboard serial</th>
                                    <td>{{ computer.baseboard_serial }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Display resolution</th>
                                    <td>{{ computer.primary_display_resolution }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Display size</th>
                                    <td>{{ computer.primary_display_size }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU vendor</th>
                                    <td>{{ computer.cpu_vendor }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU model</th>
                                    <td>{{ computer.cpu_model }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU speed</th>
                                    <td>{{ computer.cpu_speed_display }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU L2 cache</th>
                                    <td>{{ computer.cpu_l2_cache }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU L3 cache</th>
                                    <td>{{ computer.cpu_l3_cache }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU voltage</th>
                                    <td>{{ computer.cpu_voltage }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU external clock</th>
                                    <td>{{ computer.cpu_external_clock }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU stepping</th>
                                    <td>{{ computer.cpu_stepping }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU number of cores</th>
                                    <td>{{ computer.cpu_number_of_cores }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU number of thread per core</th>
                                    <td>{{ computer.cpu_threads_per_core }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU number of cores per socket</th>
                                    <td>{{ computer.cpu_cores_per_socket }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">CPU populated sockets</th>
                                    <td>{{ computer.cpu_number_of_sockets }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">USB version</th>
                                    <td>{{ computer.usb_version }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Total memory capacity</th>
                                    <td>{{ computer.memory_total_capacity_display }}</td>
                                </tr>
                            </tbody>
                        </table>
                </card>
            </div>
            <div class="col-lg-12 col-xl-5">
                <toggle-card :title="`Extra (${computer.extra.length || 0})`" showInitially>
                    <button v-if="isLocked" class="btn btn-sm btn-outline-info float-right mb-1" type="button"
                        @click="unlock()">Edit</button>
                    <b-table v-if="isLocked" thead-class="d-none" show-empty small :items="computer.extra"
                        :fields="[{ key: 'key', isRowHeader: true }, 'value']"></b-table>
                    <extras-form v-else @close="lock()" @save="saveExtras" :items="computer.extra"></extras-form>
                </toggle-card>
                <toggle-card :title="`Disk Drive (${computer.disk.length || 0})`" showInitially>
                    <b-table show-empty small :items="computer.disk"
                        :fields="['vendor', 'model', 'serial', { key: 'capacity_display', label: 'Capacity' }, { key: 'verify_result_display', label: 'Verify Result' }, { key: 'device_id', label: 'View' }]">
                        <template v-slot:cell(device_id)="row">
                            <router-link :to="`/verified/disks/${row.item.device_id}`">
                                <font-awesome-icon icon="hdd" />
                            </router-link>
                        </template>
                    </b-table>
                </toggle-card>
                <toggle-card :title="`Memory (${computer.memory.length || 0})`">
                    <b-table show-empty small :items="computer.memory"
                        :fields="['vendor', 'description', { key: 'capacity_display', label: 'Capacity' }]"></b-table>
                </toggle-card>
                <toggle-card :title="`Network (${computer.network.length || 0})`">
                    <b-table show-empty small :items="computer.network"
                        :fields="['vendor', 'model', 'type', 'mac']"></b-table>
                </toggle-card>
                <toggle-card :title="`Storage (${computer.storage.length || 0})`">
                    <b-table show-empty small :items="computer.storage"
                        :fields="['vendor', 'model', 'description']"></b-table>
                </toggle-card>
                <toggle-card :title="`Optical Drive (${computer.optical.length || 0})`">
                    <b-table show-empty small :items="computer.optical"
                        :fields="['vendor', 'model', 'description']"></b-table>
                </toggle-card>
                <toggle-card :title="`Audio (${computer.audio.length || 0})`">
                    <b-table show-empty small :items="computer.audio" :fields="['vendor', 'model']"></b-table>
                </toggle-card>
                <toggle-card :title="`Video (${computer.video.length || 0})`">
                    <b-table show-empty small :items="computer.video" :fields="['vendor', 'model']"></b-table>
                </toggle-card>
                <toggle-card :title="`Peripheral (${computer.peripheral.length || 0})`">
                    <b-table show-empty small :items="computer.peripheral" :fields="['type', 'description']"></b-table>
                </toggle-card>
                <toggle-card :title="`Port (${computer.port.length || 0})`">
                    <b-table show-empty small :items="computer.port"
                        :fields="['type', { key: 'designator', label: 'Name' }, 'connector']"></b-table>
                </toggle-card>
                <toggle-card :title="`Battery (${computer.battery.length || 0})`">
                    <b-table show-empty small :items="computer.battery"
                        :fields="['vendor', 'model', 'serial', 'technology', { key: 'energy_full_design', label: 'Design Capacity Wh' }, { key: 'energy_full', label: 'Actual Capacity Wh' }, { key: 'life_remaining_percent', label: 'Life Remaining' }]"></b-table>
                </toggle-card>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-11">
                <card title="Computer" subTitle="404 error" :isFullPage="true">
                    <div class="card-body text-center">
                        <p>No computer was found at this url</p>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { notify } from '../services/notify';

import api from '../services/api';
import ToggleCard from '../components/Cards/ToggleCard.vue';
import ExtrasForm from '../components/Forms/ExtrasForm.vue';

export default {
    name: 'ComputerVerified',
    components: {
        ExtrasForm,
        ToggleCard,
    },
    props: {
        hardware_id: String,
    },
    data() {
        return {
            computer: null,
            isLoading: false,
            isLocked: true,
        };
    },
    async created() {
        this.isLoading = true;
        try {
            const response = await api.get(`/hardwares-verified/${this.hardware_id}`);
            this.computer = response.data;
        }
        catch(err) {
            notify().error('Error fetching report.');
        }
        finally {
            this.isLoading = false;
        }
    },
    methods: {
        async unlock() {
            this.isLocked = false;
        },
        async lock() {
            this.isLocked = true;
        },
        async saveExtras(extras) {
            this.isLoading = true;
            try {
                const response = await api.put(`/hardwares-verified/${this.hardware_id}`, extras);
                this.computer = response.data;
            }
            catch(err) {
                notify().error('Error saving report.');
            }
            finally {
                this.isLoading = false;
            }
        },
        async fetchCertificate() {
            this.isLoading = true;
            try {
                const response = await api.postJSON('/hardwares-verified/export', {
                    type: 'certificate',
                    selection: [this.computer.hardware_id],
                    filename: `${this.computer.report_id}.pdf`,
                }, { responseType: 'blob' });
                const url = window.URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${this.computer.report_id}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            }
            catch(err) {
                notify().error('Error fetching certificate.');
            }
            finally {
                this.isLoading = false;
            }
        },
    },
    computed: {
        isValid() {
            return !(this.computer.hash == null || this.computer.hash == "" || this.computer.hash == "INVALID");
        },
    },
};
</script>
